import React from "react";
import { useSystemLogo } from "../../context/systemConfigContext";

const CallerStep3 = () => {
    const { logo } = useSystemLogo();
    return (
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
            <img className="w-48 mx-auto" src={logo} alt="Logo" />
            <h2 className="text-center text-[30px] font-bold leading-9 text-primary mb-10">
                Ya no quedan pacientes por atender
            </h2>
        </div>
    );
};

export default CallerStep3;
